export default {
  aboutme: { title: "About Me", href: "/#aboutme" },
  projects: { title: "Projects", href: "/#projects" },
  blog: { title: "Blog", href: "/#blog" },
  contact: { title: "Contact", href: "/#contact" },
}
